import { render, staticRenderFns } from "./custom-company-brand.vue?vue&type=template&id=64001cfb&scoped=true&"
import script from "./custom-company-brand.vue?vue&type=script&lang=js&"
export * from "./custom-company-brand.vue?vue&type=script&lang=js&"
import style0 from "./custom-company-brand.vue?vue&type=style&index=0&id=64001cfb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64001cfb",
  null
  
)

export default component.exports